import { render, staticRenderFns } from "./success.vue?vue&type=template&id=ec05195a&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default})
